import addLoadedFonts from './functions/addLoadedFonts';

document.documentElement.className = document.documentElement.className.replace(/no-js/, 'js');

addLoadedFonts();
